/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {Karen} from "../../Karen";
import {TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {KarenSymbol} from "../../symbol/KarenSymbol";
import {SpineAnimation} from "../../view/SpineAnimation";
import {KarenSoundManager} from "../../sound/KarenSoundManager";
import {KarenSoundConfig} from "../../sound/KarenSoundConfig";

export class WildLandingController extends ReelStopPresentationController {

    private _animations: TimelineLite[] = [];

    constructor() {
        super("WildLandingController");
    }

    public skip(): void {
        super.skip();
        this._animations.forEach(a => a.timeScale(2));
    }

    protected async onReelBounce(data: IReelStateEventData): Promise<any> {
        const promises: Promise<any>[] = [];
        const tween: TimelineLite = new TimelineLite();
        if (data.reelId === 5) {
            if (Karen.model.parsedGameData.doReelNudge) {
                const symIndex = Karen.model.parsedGameData.reels[5].indexOf("W");
                const symbol = Karen.reels[data.reelId].getSymbol(symIndex - 1);
                //#106
                Karen.reels[5].reelView.updateWildContainer(Karen.model.parsedGameData.evaluatedArea[5].length, false, true);
                const stagePos: PIXI.Point = symbol.getStagePosition();
                const wildAn: SpineAnimation = new SpineAnimation("wild");
                wildAn.setStagePosition(stagePos);
                wildAn.y = wildAn.y - 35;
                tween.add(wildAn.playSpineAnimation("land", this.isSkip));
                tween.add(() => {
                    KarenSoundManager.stopSoundEffect(KarenSoundConfig.WILD_NUDGE_ANTICIPATION);
                }, "-=0.2");
                tween.add(() => {
                }, tween.totalDuration() + 1);//#127 pause to show where wild landed
                if (this.isSkip) {
                    tween.timeScale(2);
                }
                this._animations.push(tween);
                promises.push(Promise.resolve(tween).then(res => {
                    ArrayHelper.removeFirstMatchElement(this._animations, tween);
                }));
            }
        }
        await Promise.all(promises);
    }
}
